export function write(name: string, value: string, expires?: number, path?: string, domain?: string, secure?: boolean) {
  const cookie = [];
  cookie.push(`${name}=${encodeURIComponent(value)}`);

  if (typeof expires === "number") {
    cookie.push(`expires=${new Date(expires).toUTCString()}`);
  }

  if (typeof path === "string") {
    cookie.push(`path=${path}`);
  }

  if (typeof domain === "string") {
    cookie.push(`domain=${domain}`);
  }

  if (secure === true) {
    cookie.push("secure");
  }

  document.cookie = cookie.join("; ");
}

export function read(name: string) {
  const match = document.cookie.match(new RegExp(`(^|;\\s*)(${name})=([^;]*)`));
  return match ? decodeURIComponent(match[3]) : undefined;
}

export function remove(name: string) {
  write(name, "", Date.now() - 86400000);
}
